import script from "./TxArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./TxArea.vue?vue&type=script&lang=ts&setup=true"

import "./TxArea.vue?vue&type=style&index=0&id=98128bcc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\33\\Desktop\\2024\\block-explorer-ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98128bcc"]])

export default __exports__